import { render, staticRenderFns } from "./AttachVolume.vue?vue&type=template&id=f147b810&scoped=true&"
import script from "./AttachVolume.vue?vue&type=script&lang=js&"
export * from "./AttachVolume.vue?vue&type=script&lang=js&"
import style0 from "./AttachVolume.vue?vue&type=style&index=0&id=f147b810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f147b810",
  null
  
)

export default component.exports